/**
 * Validation for the voucher design picker (PDF, SVG or a PNG/JPEG/WebP image), the sibling of image-file.utils.
 *
 * As there, a file passes when EITHER the MIME type OR the extension matches: mobile
 * pickers sometimes report no type at all. The backend decides by the bytes anyway.
 */

const ALLOWED_TYPES = [
  'application/pdf',
  'image/svg+xml',
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/webp',
  'image/heic',
  'image/heif',
];
const ALLOWED_EXTENSIONS = ['.pdf', '.svg', '.png', '.jpg', '.jpeg', '.webp', '.heic', '.heif'];

/** 20 MB here; the backend caps PDF at 10 MB, SVG at 5 MB, images at 15 MB and says so. */
export const MAX_DESIGN_BYTES = 20 * 1024 * 1024;

/** @returns a German error message, or `null` when the file looks usable. */
export function validateDesignFile(file: File, maxBytes = MAX_DESIGN_BYTES): string | null {
  const dot = file.name.lastIndexOf('.');
  const extension = dot >= 0 ? file.name.substring(dot).toLowerCase() : '';
  const typeOk = ALLOWED_TYPES.includes(file.type.toLowerCase());
  const extensionOk = ALLOWED_EXTENSIONS.includes(extension);

  if (!typeOk && !extensionOk) {
    return 'Ungültiges Dateiformat. Bitte wähle eine PDF-, SVG-, PNG-, JPG-, HEIC- oder WEBP-Datei.';
  }
  if (file.size > maxBytes) {
    const mb = Math.round(maxBytes / (1024 * 1024));
    return `Die Datei ist zu groß. Maximale Größe: ${mb} MB.`;
  }
  return null;
}
